import { render, staticRenderFns } from "./adminMain.vue?vue&type=template&id=6833d049&scoped=true"
import script from "./adminMain.vue?vue&type=script&lang=js"
export * from "./adminMain.vue?vue&type=script&lang=js"
import style0 from "./adminMain.vue?vue&type=style&index=0&id=6833d049&prod&lang=css"
import style1 from "./adminMain.vue?vue&type=style&index=1&id=6833d049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833d049",
  null
  
)

export default component.exports